import { of } from 'rxjs'
import { delayWhen, filter, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE, replace } from 'connected-react-router'
import { queryFromString } from 'helpers/url'
import { injectLinkTo } from 'domain/resources'
import { isOneOfOldRoutes, isOldProductRoute, toHref } from 'helpers/PathHelper'
import * as Actions from 'store/actions/index.ts'
import { getLoggedIn, getOperationCode } from '../selectors'
import { getResources } from '../reducers/resources.ts'

const waitForProductFetched$ = (resourceFetched$, productKey, state$) => resourceFetched$.pipe(
  ofType(Actions.resources.RESOURCE_FETCHED),
  delayWhen(() => {
    const currentProduct = getResources(state$.value)[productKey]
    const isCurrentProductFetched = currentProduct && currentProduct.type === 'product' && currentProduct.fetched

    return (isCurrentProductFetched)
      ? of({})
      : waitForProductFetched$(resourceFetched$, productKey, state$)
  }),
  switchMap(() => {
    const resources = getResources(state$.value)
    const currentProduct = resources[productKey]
    const scope = currentProduct.parent ? resources[currentProduct.parent] : undefined
    const opeCode = getOperationCode(state$.value)
    const productWithLink = injectLinkTo(scope, opeCode, resources, currentProduct)
    const productLink = toHref(productWithLink.linkTo)

    return of(replace(productLink))
  })
)

const RedirectRoutingEpic = (actions$, state$) => {
  const authentications$ = actions$.pipe(ofType(Actions.member.MEMBER_INFO_FETCHED))
  const resourceFetched$ = actions$.pipe(ofType(Actions.resources.RESOURCE_FETCHED))

  return actions$.pipe(
    ofType(LOCATION_CHANGE),
    filter(({ payload: { location: { pathname } } }) => isOneOfOldRoutes(pathname)),
    delayWhen(() =>
      getLoggedIn(state$.value)
        ? of({})
        : authentications$
    ),
    switchMap(({ payload: { location: { pathname, search } } }) => {
      if (isOldProductRoute(pathname)) {
        const productKey = queryFromString(search).key
        return waitForProductFetched$(resourceFetched$, productKey, state$)
      }

      return of(replace(`/${getOperationCode(state$.value)}/home`))
    })
  )
}

export default RedirectRoutingEpic
